import { api } from "../Configurations/axios";

//Get:
const CreateHirings = async (companyId: string, pleaId: string, name: string, userEmail: string) => {
    try {
        const result = await api.post(`/Hiring/Post`, {
            companyId: companyId,
            pleaId: pleaId,
            name: name,
            userEmail: userEmail
        });

        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllByCompany = async (companyId: string, page = 1, take = 7, word = "all") => {

    word = word == undefined || word == null ? "all" : word;

    const result = await api.get(`/Hiring/GetAllByCompanyId?companyId=${companyId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);

    const response = await result.data;

    return response;
}

const GetYearByHirings = async (hiringsId: string) => {

    const result = await api.get(`/Hiring/GetYearByHirings/${hiringsId}`);

    const response = await result.data;

    return response;
}
const DeleteHiringAPI = async (hiringId: string) => {
    try {
        const result = await api.delete(`/Hiring/Delete`, {data: { Id: hiringId}});
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    CreateHirings,
    GetAllByCompany,
    GetYearByHirings,
    DeleteHiringAPI
}